import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import { CHECKOUT_SUPERFICIE, CREDITOS_MODAL_ABA } from '@modules/ai-framework/constants/Text'
import { checkoutCanceladoNaUrl } from '@modules/ai-framework/utils/planos'
import {
  FASE,
  lerOrigem,
  limparOrigem,
  marcarRetorno,
} from '@modules/ai-framework/utils/retorno-do-checkout'

// `beforeEnter` das rotas de RETORNO da Stripe (`routes.js`: `aiFrameworkCreditos` e
// `aiFrameworkCreditosPagamento`). Se o consultor saiu para o checkout pelo MODAL de
// créditos, de outra rota (`guardarOrigem`, no `fluxoAssinaturaMixin`), ele volta para
// ESSA rota — `next({ path, replace })`, antes de a página de créditos existir, então ela
// não pisca — e o modal reabre na aba certa, com o que a URL de retorno trazia.
//
// ★ Só a navegação INICIAL conta como volta da Stripe: o checkout sai do SPA, e o retorno
// é sempre uma carga completa da página (`from` é a rota START, sem `matched`). Chegar
// aqui por navegação de dentro do app (clicou em "Créditos" no menu) com uma origem
// gravada quer dizer que o consultor NÃO passou pelo retorno — voltou pelo histórico do
// navegador, por exemplo —, e a origem é lixo: apagada, e a página abre normal.
//
// O `GlobalBus.$emit` pode se perder se o modal (componente assíncrono de
// `global-modals.vue`) ainda não montou; por isso o payload também vai para o registro
// (`marcarRetorno`) e o `created` do modal o consome.
const ROTA_PAGAMENTO = 'aiFrameworkCreditosPagamento'

function navegacaoInicial(from) {
  return !from || !Array.isArray(from.matched) || from.matched.length === 0
}

// O que o modal precisa para reabrir onde o consultor parou. Retorno do pagamento AVULSO
// tem o id na URL → aba Adicionar, com o estado do pagamento. Retorno para a página de
// créditos (sem id) é a ASSINATURA (paga ou desistida, `?checkout=cancelado`) — ou a
// desistência da compra avulsa, que o backend manda para a mesma rota: a aba gravada na
// ida é o que separa as duas.
function retornoDaRota(to, origem) {
  if (to.name === ROTA_PAGAMENTO) {
    const idPagamento = (to.params && to.params.idPagamento) || null
    return { aba: CREDITOS_MODAL_ABA.ADICIONAR, idPagamento, checkoutCancelado: false }
  }
  return {
    aba: origem.aba || CREDITOS_MODAL_ABA.PLANOS,
    idPagamento: null,
    checkoutCancelado: checkoutCanceladoNaUrl(to.query),
  }
}

function retornoDoCheckoutGuard(to, from, next) {
  const origem = lerOrigem()
  if (!origem || origem.fase !== FASE.IDA) {
    next()
    return
  }
  if (!navegacaoInicial(from) || origem.superficie !== CHECKOUT_SUPERFICIE.MODAL) {
    limparOrigem()
    next()
    return
  }
  const retorno = retornoDaRota(to, origem)
  marcarRetorno(retorno)
  GlobalBus.$emit(MODAL.AI_FRAMEWORK_CREDITOS, retorno)
  next({ path: origem.rota, replace: true })
}

export { retornoDoCheckoutGuard, retornoDaRota, navegacaoInicial }
